import { useState } from 'react'

import { BlackCheckBox } from '../atoms/blackCheckBox';
import { Label } from '../atoms/label';
import { Image } from '../atoms/image';
import img_top from '../../resources/icons/ico_arrow_top.svg';
import img_bottom from '../../resources/icons/ico_arrow_bottom.svg';

export const CheckboxSeachSetForm = (props) => {
    const { title, checkData, onChange } = props;

    const [showFlg, setShowFlg] = useState(true);

    const onClickShowFlg = () => {
        setShowFlg(!showFlg);
    };

    return (
        <div>
            <div onClick={onClickShowFlg} style={styles.header}>
                <Label label={title} style={styles.title} />
                <div style={styles.icon}>
                    <Image image={showFlg ? img_top : img_bottom} />
                </div>
            </div>
            <div style={showFlg ? { display: "block" } : { display: "none" }}>
                {checkData.map((data, index) => (
                    <BlackCheckBox
                        key={index}
                        id={data.value}
                        className={data.class}
                        onChange={onChange}
                        item={data.value}
                        value={data.id}
                        defaultChecked={data.checked} />
                ))}
            </div>
        </div>
    );
}
const styles = {
    header: {
        display: "table",
        width: "100%",
        marginBottom: "10px",
    },
    title: {
        display: "table-cell",
        fontSize: "small",
        cursor: "pointer",
        color: "#808080",
        fontSize: "small",
        fontWeight: "bold",
    },
    icon: {
        display: "table-cell",
        textAlign: "right",
        cursor: "pointer",
        width: "16px",
        marginRight: "5px",
    },
}